// 市场解读tab
import { forwardRef, useImperativeHandle } from 'react';
import ActionBar from '@/components/SelectSend';
import { useMemo, useState } from 'react';
import { SummarySelect } from '../MarketInterpretationTab/index';
// import { SkeletonDashboard } from '@/components/loading/Skeleton';
// import { isCanParseJson } from '@/lib/utils';
import { ShieldAlert } from 'lucide-react';
import useCopilotValueStore from '@/stores/copilotValueStore';

interface MarketInterpretationRef {
  resetSelectedValues: () => void;
}

const MarketInterpretation = forwardRef<MarketInterpretationRef, { userQuestion: string }>(
  ({ userQuestion }, ref) => {
    const { copilotValue11 } = useCopilotValueStore();
    const totalData = useMemo(() => copilotValue11, [copilotValue11]);
    const loading = useMemo(() => copilotValue11.loading, [copilotValue11.loading]);
    const [selectedMetrics, setSelectedMetrics] = useState({
      policy_environment_analysis: false,
      industry_trend_analysis: false,
      leading_enterprise_analysis: false,
      investment_recommendations: false
    });
    // 全选状态
    const selectAll = useMemo(() => {
      const values = Object.values(selectedMetrics);
      console.log(values, 'values');
      return values.length > 0 && values.every(v => v);
    }, [selectedMetrics]);

    // 半选状态
    const isIndeterminate = useMemo(() => {
      const values = Object.values(selectedMetrics);
      const checkedCount = values.filter(v => v).length;
      return checkedCount > 0 && checkedCount < values.length;
    }, [selectedMetrics]);
    // 处理全选
    const handleSelectAll = (value: boolean) => {
      const newMetrics = { ...selectedMetrics };
      Object.keys(newMetrics).forEach(key => {
        newMetrics[key as keyof typeof selectedMetrics] = value;
      });
      setSelectedMetrics(newMetrics);
    };

    const handleSelectChange = (key: string, checked: boolean) => {
      setSelectedMetrics(prev => ({
        ...prev,
        [key]: checked
      }));
    };

    const resetSelectedValues = () => {
      console.log('resetSelectedValues MarketInterpretationTab');
      setSelectedMetrics({
        policy_environment_analysis: false,
        industry_trend_analysis: false,
        leading_enterprise_analysis: false,
        investment_recommendations: false
      });
    };

    useImperativeHandle(ref, () => ({
      resetSelectedValues
    }));

    if (loading) {
      return (
        <div className="min-h-[200px] text-center text-sm text-black">
          Ai已识别客户投顾需求，正在检索市场行情数据生成完整洞察内容，请稍后…
        </div>
      );
    }

    return (
      <>
        <div
          className="flex h-full w-full flex-col gap-3 pb-[56px]"
          id="marketInterpretation-tab-page"
        >
          <SummarySelect
            title="政策环境分析"
            conclusion={totalData.policy_environment_analysis}
            type="policy_environment_analysis"
            selected={selectedMetrics.policy_environment_analysis}
            selectChange={handleSelectChange}
            userQuestion={userQuestion}
          />

          {/* 消费板块解读 */}
          <SummarySelect
            title="行业趋势分析"
            conclusion={totalData.industry_trend_analysis}
            variant="green"
            type="industry_trend_analysis"
            selected={selectedMetrics.industry_trend_analysis}
            selectChange={handleSelectChange}
            userQuestion={userQuestion}
          />

          {/* 布局时机判断 */}
          <SummarySelect
            title="龙头企业分析"
            conclusion={totalData.leading_enterprise_analysis}
            variant="lightPurple"
            type="leading_enterprise_analysis"
            selected={selectedMetrics.leading_enterprise_analysis}
            selectChange={handleSelectChange}
            userQuestion={userQuestion}
          />

          <SummarySelect
            title="投资建议"
            conclusion={totalData.investment_recommendations}
            variant="blue"
            type="investment_recommendations"
            selected={selectedMetrics.investment_recommendations}
            selectChange={handleSelectChange}
            userQuestion={userQuestion}
          />

          <div className="flex rounded-[6px] bg-[#FFF1F0] p-1">
            <ShieldAlert size={16} color="#F5222D" />
            <span className="ml-1 text-left text-xs leading-5 text-[#F5222D]">
              风险提示：以上分析仅供参考，投资有风险，入市需谨慎。请根据自身风险承受能力谨慎决策
            </span>
          </div>
        </div>
        {/* 操作栏 */}
        <ActionBar
          selectAll={selectAll}
          isIndeterminate={isIndeterminate}
          onUpdateSelectAll={handleSelectAll}
          selectedMetrics={selectedMetrics}
          tabType="marketInterpretation"
          isFixed={true}
        />
      </>
    );
  }
);

MarketInterpretation.displayName = 'MarketInterpretation';

export default MarketInterpretation;
